import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import axios from "axios";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../../APIHelpers/Responses";

export const editorSuperAdminDataServices = {
  getLibraryFileData,
  getDatasetByLibraryId,
};

// get Library Folder Data,
async function getLibraryFileData(status, category) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getLibraryFileData/${status}/${category}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Library Data by Folder Id
async function getDatasetByLibraryId(libraryId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getDatasetByLibraryId/${libraryId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}